import { useQueryClient } from "@tanstack/react-query";

import { getGetDealShortlistQueryKey } from "@vega-api/generated/coinvest-deal-shortlist/coinvest-deal-shortlist";
import { useCreateOrAddDealShortlistFromCsvUploadV2 } from "@vega-api/generated/coinvest-deal-shortlist-upload/coinvest-deal-shortlist-upload";

import { PROSPECTS_CSV_UPLOAD_INPUT_ID } from "../../constants/prospectsUpload";

import { useDealCsvUpload } from "./useDealCsvUpload";

type UseProspectsCsvUploadParams = {
  dealId: string;
  onUploadSuccess?: () => void;
};

export const useProspectsCsvUpload = ({
  dealId,
  onUploadSuccess,
}: UseProspectsCsvUploadParams) => {
  const queryClient = useQueryClient();
  const uploadMutation = useCreateOrAddDealShortlistFromCsvUploadV2();

  return useDealCsvUpload({
    dealId,
    uploadMutation,
    inputElementId: PROSPECTS_CSV_UPLOAD_INPUT_ID,
    onUploadSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getGetDealShortlistQueryKey(dealId),
      });
      onUploadSuccess?.();
    },
  });
};
